import React, { JSX } from "react";

type IndustryCardProps = {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt?: string;
  icon?: JSX.Element;
  className?: string;
  onClick?: () => void;
};

export const IndustryCard: React.FC<IndustryCardProps> = ({
  title,
  description,
  imageSrc,
  imageAlt = title,
  icon,
  className = "",
  onClick,
}) => {
  return (
    <article
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (!onClick) return;
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
      className={[
        "group overflow-hidden rounded-2xl border-2 border-[#2C73DB] bg-[#2C73DB]",
        "transition-transform duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(37,99,235,0.18)]",
        onClick ? "cursor-pointer" : "",
        className,
      ].join(" ")}
    >
      <div className="p-2">
        <div className="overflow-hidden rounded-xl bg-slate-100">
          <img
            src={imageSrc}
            alt={imageAlt}
            loading="lazy"
            className="h-[270px] w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]"
          />
        </div>
      </div>

      <div className="bg-[#2C73DB] px-4 pb-5 pt-4 text-white">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-white/15 ring-1 ring-white/25">
            {icon ? (
              <span className="text-white">{icon}</span>
            ) : (
              <span className="h-2 w-2 rounded-full bg-white" />
            )}
          </span>

          <h3 className="text-sm font-semibold leading-tight">{title}</h3>
        </div>

        <p className="mt-2 ml-9 text-xs leading-5 text-white/85">
          {description}
        </p>
      </div>
    </article>
  );
};
